<template>
  <div id="search">
    <div class="container-fluid">
      <!-- Filter -->
      <section class="filter">
        <!-- Right Side (Category Section) -->
        <div class="category right-side">
          <!-- Top Text -->
          <div class="text mb-3">
            <span>نتیجه جستجــــو</span>
            <span>"{{ this.keyword || "همـــه" }}"</span>
          </div>
          <!-- End Top Text -->

          <!-- Radio Buttons -->
          <b-form-radio-group
            v-model="selectedCategory"
            :options="radioOptions"
            class="mb-3"
            value-field="value"
            text-field="name"
            disabled-field="notEnabled"
          ></b-form-radio-group>
          <!-- End Radio Buttons -->
        </div>
        <!-- End Right Side (Category Section) -->

        <!-- Left Side (Search Section) -->
        <div class="search left-side">
          <!-- Search Box -->
          <form @submit="searchKeyword">
            <input
              type="text"
              name="keyword"
              :value="this.$route.params.keyword"
              placeholder="جستجوی کسب و کار، استارتاپ، محصول، خدمات"
            />
            <button type="submit">
              <i class="icon-search-panel"></i>
            </button>
          </form>
          <!-- End Search Box -->
        </div>
        <!-- End Left Side (Search Section) -->
      </section>
      <!-- End Filter -->

      <div class="row">
        <!-- Category Items -->
        <div class="col-lg-10">
          <div class="row category-items">
            <!-- Business Header -->
            <div class="col-xl-12" v-if="selectedCategory == 'all'">
              <div class="category-heading">
                <h1>کسب و کارها :</h1>
              </div>
            </div>
            <!-- End Business Header -->

            <!-- No Business Message -->
            <div
              class="col-xl-12 text-white font-size-12 mb-2"
              v-if="businessItems.length == 0"
            >
              موردی یافت نشد.
            </div>
            <!-- End No Business Message -->

            <!-- Business Item -->
            <router-link
              v-for="(item, index) in businessItems"
              :key="index + '-business'"
              class="col-one-fifth col-lg-3 col-md-4 col-sm-6 category-item business-item"
              tag="div"
              :to="`/${item.username}`"
            >
              <div class="item-wrap">
                <div
                  class="wishlist"
                  @click="toggleWishlist(item.id)"
                  :is-wish="item.is_wish"
                >
                  <i class="icon-wishlist-line not-wish"></i>
                  <i class="icon-wishlist wished"></i>
                </div>
                <div
                  class="techchi-rate"
                  v-b-tooltip.hover
                  title="رتبه ارزیابی تکچی"
                >
                  <div class="techchi-point">87</div>
                  <i class="icon-techchi"></i>
                </div>
                <div class="image">
                  <img :src="getImageUrl(item.img_url, 'business', 'business.jpg')" :alt="item.title" />
                </div>
                <h2 class="title">{{ item.title | summarizeTitle }}</h2>

                <StarRating :rate="item.rate" />
              </div>
            </router-link>
            <!-- End Business Item -->

            <!-- More Business Item Loader -->
            <div
              class="col-one-fifth col-lg-3 col-md-4 col-sm-6 more-data"
              v-if="selectedCategory == 'all'"
              v-show="hasNextItem.business"
            >
              <div class="more-data-wrap" @click="getMoreData('business')">
                <i class="icon-more-vertical"></i>
                <p>بیشتر</p>
              </div>
            </div>
            <!-- End More Business Item Loader -->

            <!-- Product Header -->
            <div class="col-xl-12" v-if="selectedCategory == 'all'">
              <div class="category-heading">
                <hr />
                <h1>محصولات :</h1>
              </div>
            </div>
            <!-- End Product Header -->

            <!-- No Product Message -->
            <div
              class="col-xl-12 text-white font-size-12 mb-2"
              v-if="productItems.length == 0"
            >
              موردی یافت نشد.
            </div>
            <!-- End No Product Message -->

            <!-- Product Item -->
            <router-link
              v-for="(item, index) in productItems"
              :key="index + '-product'"
              class="col-one-fifth col-lg-3 col-md-4 col-sm-6 category-item product-item"
              tag="div"
              :to="`/product/${item.business_username}/${item.business_id}/${item.id}`"
            >
              <div class="item-wrap">
                <div class="image">
                  <img :src="getImageUrl(item.main_img, 'product', 'product.jpg')" :alt="item.title" />
                  <div class="image-overlay">
                    <button v-b-tooltip.hover title="افزودن به علاقه مندی">
                      <i class="icon-heart"></i>
                    </button>
                    <!--                                        <button>-->
                    <!--                                            <i class="icon-plus"></i>-->
                    <!--                                        </button>-->
                  </div>
                </div>
                <div class="content">
                  <h2 class="title">
                    <i class="icon-heart"></i>
                    {{ item.title | summarizeTitle }}
                  </h2>
                  <p class="inventory_status">موجود</p>
                  <div class="price">
                    <div class="right">
                      <span class="discount-percent">تخفیف 50%</span>
                    </div>
                    <div class="left">
                      <span class="main-price">6000 تومان</span>
                      <span class="discount-price">3000 تومان</span>
                    </div>
                  </div>
                  <div class="supplier">
                    <span class="title">تامین کننده:</span>
                    <span class="value">{{ item.business_title }}</span>
                  </div>
                </div>
              </div>
            </router-link>
            <!-- End Product Item -->

            <!-- More Product Item Loader -->
            <div
              class="col-one-fifth col-lg-3 col-md-4 col-sm-6 more-data"
              v-if="selectedCategory == 'all'"
              v-show="hasNextItem.product"
            >
              <div class="more-data-wrap" @click="getMoreData('product')">
                <i class="icon-more-vertical"></i>
                <p>بیشتر</p>
              </div>
            </div>
            <!-- End More Product Item Loader -->

            <!-- Service Header -->
            <div class="col-xl-12" v-if="selectedCategory == 'all'">
              <div class="category-heading">
                <hr />
                <h1>خدمات :</h1>
              </div>
            </div>
            <!-- End Service Header -->

            <!-- No Service Message -->
            <div
              class="col-xl-12 text-white font-size-12 mb-2"
              v-if="serviceItems.length == 0"
            >
              موردی یافت نشد.
            </div>
            <!-- End No Service Message -->

            <!-- Service Item -->
            <router-link
              v-for="(item, index) in serviceItems"
              :key="index + '-service'"
              class="col-one-fifth col-lg-3 col-md-4 col-sm-6 category-item product-item"
              tag="div"
              :to="`/service/${item.business_username}/${item.business_id}/${item.id}`"
            >
              <div class="item-wrap">
                <div class="image">
                  <img :src="getImageUrl(item.img, 'service', 'service.jpg')" :alt="item.title" />
                  <div class="image-overlay">
                    <button v-b-tooltip.hover title="افزودن به علاقه مندی">
                      <i class="icon-heart"></i>
                    </button>
                    <!--                                        <button>-->
                    <!--                                            <i class="icon-plus"></i>-->
                    <!--                                        </button>-->
                  </div>
                </div>
                <div class="content">
                  <h2 class="title">
                    <i class="icon-heart"></i>
                    {{ item.title | summarizeTitle }}
                  </h2>
                  <p class="inventory_status">موجود</p>
                  <div class="price">
                    <div class="right">
                      <span class="discount-percent">تخفیف 50%</span>
                    </div>
                    <div class="left">
                      <span class="main-price">6000 تومان</span>
                      <span class="discount-price">3000 تومان</span>
                    </div>
                  </div>
                  <div class="supplier">
                    <span class="title">تامین کننده:</span>
                    <span class="value">{{ item.business_title }}</span>
                  </div>
                </div>
              </div>
            </router-link>
            <!-- End Service Item -->

            <!-- More Service Item Loader -->
            <div
              class="col-one-fifth col-lg-3 col-md-4 col-sm-6 more-data"
              v-if="selectedCategory == 'all'"
              v-show="hasNextItem.service"
            >
              <div class="more-data-wrap" @click="getMoreData('service')">
                <i class="icon-more-vertical"></i>
                <p>بیشتر</p>
              </div>
            </div>
            <!-- End More Service Item Loader -->
          </div>
        </div>
        <!-- End Category Items -->

        <!-- Advertising Section -->
        <div class="col-lg-2">
          <div class="advertising">
            <!-- <img
              class="w-100"
              :src="require(`@/assets/images/search/ad.jpg`)"
              alt="تبلیغات"
            /> -->
          </div>
        </div>
        <!-- End Advertising Section -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/axios.js";
import StarRating from "@/pages/search/components/StarRating.vue";
import { url, getImageUrl } from "@/mixins.js";

export default {
  name: "search",
  mixins: [url, getImageUrl],
  components: {
    StarRating,
  },
  data() {
    return {
      selectedCategory: "all",
      radioOptions: [
        { value: "all", name: "همه" },
        { value: "business", name: "کسب و کارها" },
        { value: "product", name: "محصولات" },
        { value: "service", name: "خدمات" },
      ],
      filter: {
        start_point: 0,
        per_page: 10,
        all_index: 12,
        all_category: {
          business_start_point: 4,
          product_start_point: 4,
          service_start_point: 4,
          business_index: 1,
          product_index: 1,
          service_index: 1,
        },
      },
      businessItems: [],
      productItems: [],
      serviceItems: [],
      hasNextItem: {
        business: false,
        product: false,
        service: false,
      },
      keyword: this.$route.params.keyword,
      errors: {
        wishlist: {
          success: "عملیات با موفقیت انجام شد.",
          failure: "یک مشکل سیستمی پیش آمده است.",
          unable_to_set: "یک مشکل سیستمی پیش آمده است.",
          login_err: "برای انجام این عمل ابتدا باید وارد شوید.",
          no_record: "کسب و کار مورد نظر وجود ندارد.",
        },
      },
    };
  },

  methods: {
    getData() {
      console.log("mmmmmm:getdata");
      axios
        .get("mixed-search/mixed-search.php", {
          params: {
            keyword: this.keyword,
            filter: this.selectedCategory, // business or product or service
            per_page: this.filter.per_page,
            start_point: this.filter.start_point,
          },
        })
        .then((data) => {
          console.log("mmmmmm:", data.data);
          switch (this.selectedCategory) {
            case "business":
              this.businessItems = data.data;
              break;
            case "product":
              this.productItems = data.data;
              break;
            case "service":
              this.serviceItems = data.data;
              break;
          }
        })
        .catch((err) => console.error("Error Search page::", err));
    },

    async getAllCategoryData() {

      // get business
      await axios
        .get("mixed-search/mixed-search.php", {
          params: {
            keyword: this.keyword || "",
            filter: "business", // business or product or service
            per_page: 5,
            start_point: 0,
          },
        })
        .then((data) => {
          console.log("getAllCategoryData :", data.data);
          // check if number business is grater than 4
          this.hasNextItem.business = data.data.length > 4 ? true : false;

          this.businessItems = [];
          this.businessItems = data.data.slice(0, 4);
        })
        .catch((err) => console.error("Error Search page::", err));

      // get product
      await axios
        .get("mixed-search/mixed-search.php", {
          params: {
            keyword: this.keyword,
            filter: "product", // business or product or service
            per_page: 5,
            start_point: 0,
          },
        })
        .then((data) => {
          // check if number product is grater than 4
          this.hasNextItem.product = data.data.length > 4 ? true : false;

          this.productItems = [];
          this.productItems = data.data.slice(0, 4);
        })
        .catch((err) => console.error("Error Search page::", err));

      // get service
      await axios
        .get("mixed-search/mixed-search.php", {
          params: {
            keyword: this.keyword,
            filter: "service", // business or product or service
            per_page: 5,
            start_point: 0,
          },
        })
        .then((data) => {
          // check if number service is grater than 4
          this.hasNextItem.service = data.data.length > 4 ? true : false;

          this.serviceItems = [];
          this.serviceItems = data.data.slice(0, 4);
        })
        .catch((err) => console.error("Error Search page::", err));
    },

    getMoreData(category) {
      var per_page;
      var start_point;

      switch (category) {
        case "business":
          per_page =
            this.filter.all_index * this.filter.all_category.business_index;
          start_point = this.filter.all_category.business_start_point;
          this.filter.all_category.business_index *= 2;
          this.filter.all_category.business_start_point += per_page;
          break;
        case "product":
          per_page =
            this.filter.all_index * this.filter.all_category.product_index;
          start_point = this.filter.all_category.product_start_point;
          this.filter.all_category.product_index *= 2;
          this.filter.all_category.product_start_point += per_page;
          break;
        case "service":
          per_page =
            this.filter.all_index * this.filter.all_category.service_index;
          start_point = this.filter.all_category.service_start_point;
          this.filter.all_category.service_index *= 2;
          this.filter.all_category.service_start_point += per_page;
          break;
      }

      // get business
      axios
        .get("mixed-search/mixed-search.php", {
          params: {
            keyword: this.keyword,
            filter: category, // business or product or service
            per_page: per_page,
            start_point: start_point,
          },
        })
        .then((data) => {
          switch (category) {
            case "business":
              this.businessItems = this.businessItems.concat(data.data);
              break;
            case "product":
              this.productItems = this.productItems.concat(data.data);
              break;
            case "service":
              this.serviceItems = this.serviceItems.concat(data.data);
              break;
          }
        })
        .catch((err) => console.error("Error Search page::", err));
    },

    getDataByScroll() {
      let bottomOfWindow =
        document.documentElement.scrollTop + window.innerHeight ===
        document.documentElement.offsetHeight;

      if (bottomOfWindow && this.selectedCategory != "all") {
        this.filter.start_point += this.filter.per_page;

        axios
          .get("mixed-search/mixed-search.php", {
            params: {
              keyword: this.keyword,
              filter: this.selectedCategory, // business or product or service
              per_page: this.filter.per_page,
              start_point: this.filter.start_point,
            },
          })
          .then((data) => {
            switch (this.selectedCategory) {
              case "business":
                this.businessItems = this.businessItems.concat(data.data);
                break;
              case "product":
                this.productItems = this.productItems.concat(data.data);
                break;
              case "service":
                this.serviceItems = this.serviceItems.concat(data.data);
                break;
            }
          })
          .catch((err) => console.error("Error Search page::", err));
      }
    },

    searchKeyword() {
      event.preventDefault();

      this.resetData();
      this.keyword = event.target.keyword.value;
      this.$router.push(`/search/${this.keyword}`).catch(() => {});
      console.log("searchKeyword", this.keyword);
      if (this.selectedCategory == "all") {
        this.getAllCategoryData();
      } else {
        this.getData();
      }
    },

    toggleWishlist(businessId) {
      var clickedElement = event.target;
      var isWish = event.target.getAttribute("is-wish");

      if (isWish == "1") {
        axios
          .post("business/delete_wishlist.php", {
            business_id: businessId,
          })
          .then((data) => {
            switch (data.data.msg) {
              case "success":
                clickedElement.setAttribute("is-wish", "0");
                this.$snotify.success(this.errors.wishlist[data.data.msg]);
                break;

              case "failure":
                this.$snotify.warning(this.errors.wishlist[data.data.msg]);
                break;

              case "unable_to_set":
                this.$snotify.warning(this.errors.wishlist[data.data.msg]);
                break;

              case "login_err":
                this.$snotify.warning(this.errors.wishlist[data.data.msg]);
                break;

              case "no_record":
                this.$snotify.warning(this.errors.wishlist[data.data.msg]);
                break;

              default:
                this.$snotify.warning("خطایی رخ داده، دوباره تلاش کنید");
            }
          })
          .catch((err) => console.error("Error wish:", err));
      } else {
        axios
          .post("business/create_wishlist.php", {
            business_id: businessId,
          })
          .then((data) => {
            switch (data.data.msg) {
              case "success":
                clickedElement.setAttribute("is-wish", "1");
                this.$snotify.success(this.errors.wishlist[data.data.msg]);
                break;

              case "failure":
                this.$snotify.warning(this.errors.wishlist[data.data.msg]);
                break;

              case "unable_to_set":
                this.$snotify.warning(this.errors.wishlist[data.data.msg]);
                break;

              case "login_err":
                this.$snotify.warning(this.errors.wishlist[data.data.msg]);
                break;

              case "no_record":
                this.$snotify.warning(this.errors.wishlist[data.data.msg]);
                break;

              default:
                this.$snotify.warning("خطایی رخ داده، دوباره تلاش کنید");
            }
          })
          .catch((err) => console.error("Error wish:", err));
      }
    },

    resetData() {
      this.businessItems = [];
      this.productItems = [];
      this.serviceItems = [];
      this.filter.start_point = 0;
      this.filter.all_category.business_start_point = 4;
      this.filter.all_category.product_start_point = 4;
      this.filter.all_category.service_start_point = 4;
      this.filter.all_category.business_index = 1;
      this.filter.all_category.product_index = 1;
      this.filter.all_category.service_index = 1;
    },
  },

  filters: {
    summarizeTitle(val) {
      // var title = val.length < 25 ? val : val.substring(0, 25) + "...";
      return val;
    },
  },

  mounted() {
    // window.addEventListener("scroll", this.getDataByScroll);
    this.getAllCategoryData();
  },

  watch: {
    selectedCategory: function () {
      this.resetData();

      if (this.selectedCategory == "all") {
        this.getAllCategoryData();
      } else {
        this.getData();
      }
    },
  },
};
</script>
